import styled from 'styled-components'
import { BLUE_PRINCIPAL } from '../../utils/colors'

export const ContainerVerify = styled.div`
  text-align: center;
  margin-top: -30px;

  h3 {
    margin-bottom: 22px;
  }

  font-family: Mont, sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 32px;
  color: ${BLUE_PRINCIPAL};
`
